<span *ngIf="!expanded" class="helppoint">
    <i *ngIf="!useIonic" class="helppoint-icon" [ngClass]="icon" aria-hidden="true" (click)="clickHelpNoIonic($event)"
        title="{{gettext()}}" style="float:left;font-size: 18px;"></i>
    <i *ngIf="useIonic" class="helppoint-icon" [ngClass]="icon" aria-hidden="true" (click)="clickHelpIonic($event)"
        title="{{gettext()}}" style="float:left;font-size: 18px;"></i>
</span>
<div *ngIf="expanded" class="helppoint">
    <i [ngClass]="icon" style="float:left;font-size: 18px;"></i>
    <div style="float:left; width:calc(100% - 30px); padding-top: 2px;" class="helppoint-text">{{gettext()}}</div>
</div>